module.exports = __webpack_public_path__ + "img/root-data-zh.ad940b55.png";